import axios from "axios";
import { setLoader } from "../Store/Slice/CommonSlice";
import { store } from "../Store/store";
import { BACKEND_BASE, BACKEND_DOMAIN } from "./baseUrl";
import { logoutSuccess } from "../Store/Slice/LoginSlice";
const { dispatch } = store;
export const APIBaseUrl = axios.create({
  baseURL: `${BACKEND_DOMAIN}${BACKEND_BASE}`,
});

APIBaseUrl.interceptors.request.use(
  (config) => {
    if (config.method !== "get");
    try {
      const state = store.getState();
      let token = null;
      if (state?.auth?.isLoggedIn && state?.auth?.accessToken) {
        token = state.auth.accessToken;
      } else if (!state?.auth?.isLoggedIn && state?.auth?.accessToken) {
        token = state.auth.accessToken;
      }
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    } catch (e) {
      console.log(e.message);
    }
    return config;
  },
  (error) => {
    store.dispatch(setLoader(false));
    return Promise.reject(error);
  }
);

APIBaseUrl.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

APIBaseUrl.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log(error, "ddddd");
    if (error?.response?.status === 401) {
      //   dispatch(logoutSuccess());
      localStorage.clear();
      window.location.href = "/Login";
    }

    return Promise.reject(error);
  }
);
